import { CSSObject } from '@chakra-ui/react';

export const ILink: CSSObject = {
  mx: '0',
  textDecoration: 'underline',
  '&&': {
    color: 'beta.500',
  },
};
